import { render, staticRenderFns } from "./comp-partner-budget.vue?vue&type=template&id=d61a671e&scoped=true"
import script from "./comp-partner-budget.vue?vue&type=script&lang=js"
export * from "./comp-partner-budget.vue?vue&type=script&lang=js"
import style0 from "./comp-partner-budget.vue?vue&type=style&index=0&id=d61a671e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61a671e",
  null
  
)

export default component.exports